module.exports = __webpack_public_path__ + "static/img/1.e1268ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/19/sp/1.png
// module id = 1noz
// module chunks = 0